/**
 * The catalog keys of the plan set's datasheets (Equipment step), in one place: `t(DATASHEET_TEXT.title)`. The English
 * messages are in src/i18n/locales/en/permit.json (`permit.datasheet.*`): one message per full sentence, named
 * placeholders. Plain words: no hosts, settings or provider details (docs/contributing/user-facing-messages.md).
 */
import type { MessageKey } from "../i18n/keys";

export const DATASHEET_TEXT = {
  title: "permit.datasheet.title",
  descriptionAttached: "permit.datasheet.descriptionAttached",
  descriptionMissing: "permit.datasheet.descriptionMissing",
  supportingTitle: "permit.datasheet.supportingTitle",
  supportingDescription: "permit.datasheet.supportingDescription",
  supportingKind: {
    span_table: "permit.datasheet.supportingKind.spanTable",
    cert_letter: "permit.datasheet.supportingKind.certLetter",
  } as Record<string, MessageKey>,
  origin: {
    company: "permit.datasheet.origin.company",
    solar_os: "permit.datasheet.origin.solarOs",
    library: "permit.datasheet.origin.library",
  } as Record<string, MessageKey>,
  originHint: {
    company: "permit.datasheet.originHint.company",
    solar_os: "permit.datasheet.originHint.solarOs",
    library: "permit.datasheet.originHint.library",
  } as Record<string, MessageKey>,
  /** {pages} */
  attached: "permit.datasheet.attached",
  /** {first}, {last}, {total} */
  attachedPart: "permit.datasheet.attachedPart",
  willFetch: "permit.datasheet.willFetch",
  willFetchHint: "permit.datasheet.willFetchHint",
  referenced: "permit.datasheet.referenced",
  referencedHint: "permit.datasheet.referencedHint",
  missing: "permit.datasheet.missing",
  generic: "permit.datasheet.generic",
  officialPage: "permit.datasheet.officialPage",
  officialPageHint: "permit.datasheet.officialPageHint",
  view: "permit.datasheet.view",
  viewHint: "permit.datasheet.viewHint",
  attach: "permit.datasheet.attach",
  /** {label}: the input's accessible name */
  attachFor: "permit.datasheet.attachFor",
  replace: "permit.datasheet.replace",
  remove: "permit.datasheet.remove",
  /** {label} */
  attachedToast: "permit.datasheet.attachedToast",
  /** {label} */
  removedToast: "permit.datasheet.removedToast",
  notPdf: "permit.datasheet.notPdf",
  tooLarge: "permit.datasheet.tooLarge",
  viewFailed: "permit.datasheet.viewFailed",
} as const satisfies Record<string, MessageKey | Record<string, MessageKey>>;
